var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.02944 10.5414C1.02944 10.7829 1.12538 11.0145 1.29616 11.1853C1.46694 11.3561 1.69857 11.452 1.94009 11.452L8.35428 11.452C8.5958 11.452 8.82743 11.3561 8.99821 11.1853C9.16899 11.0145 9.26494 10.7829 9.26494 10.5414L9.26494 9.82866C9.26494 9.54439 9.49538 9.31395 9.77965 9.31395C10.0639 9.31395 10.2944 9.54439 10.2944 9.82866L10.2944 10.5414C10.2944 11.0559 10.09 11.5494 9.72613 11.9132C9.3623 12.277 8.86882 12.4814 8.35428 12.4814L1.94009 12.4814C1.42555 12.4814 0.932078 12.277 0.56824 11.9132C0.204402 11.5494 -6.23127e-08 11.0559 -8.48042e-08 10.5414L-3.65177e-07 4.12717C-3.87669e-07 3.61262 0.204402 3.11915 0.56824 2.75531C0.932078 2.39148 1.42555 2.18707 1.94009 2.18707L2.65278 2.18707C2.93705 2.18707 3.1675 2.41752 3.1675 2.70179C3.1675 2.98606 2.93705 3.21651 2.65278 3.21651L1.94009 3.21651C1.69857 3.21651 1.46694 3.31245 1.29616 3.48324C1.12538 3.65402 1.02944 3.88565 1.02944 4.12717L1.02944 10.5414Z",
    fill: "#2468FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38984 2.70215C6.38984 2.41788 6.62029 2.18743 6.90456 2.18743L9.81625 2.18743C10.1005 2.18743 10.331 2.41788 10.331 2.70215L10.331 5.61384C10.331 5.89811 10.1005 6.12856 9.81625 6.12856C9.53198 6.12856 9.30153 5.89811 9.30153 5.61384L9.30153 3.21687L6.90456 3.21687C6.62029 3.21687 6.38984 2.98642 6.38984 2.70215Z",
    fill: "#2468FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60918 2.63889C9.81228 2.83779 9.83463 3.14433 9.6591 3.32358L3.9382 9.16557C3.76266 9.34482 3.45572 9.32889 3.25261 9.13C3.04951 8.93111 3.02716 8.62456 3.20269 8.44531L8.9236 2.60332C9.09913 2.42407 9.40607 2.44 9.60918 2.63889Z",
    fill: "#2468FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.68208089da43cbda1150a2a40da7a3bd.svg";
export { ForwardRef as ReactComponent };